import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Members() {
  const [selectedMember, setSelectedMember] = useState<number | null>(null);
  const [activeFilter, setActiveFilter] = useState<string>('全部');
  const navigate = useNavigate();

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = selectedMember !== null ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [selectedMember]);

  const members = [
    {
      name: '許政賓',
      industry: '人力資源業',
      avatar: 'https://static.readdy.ai/image/5ea2d03b33219ef9494c85fcc936fae1/f76bc3c48fa56201ed549cce865a84f7.jpeg',
      company: '順新國際人力資源有限公司',
      position: '經理',
      isPresident: true,
      specialties: ['人力資源', '越南語', '英語'],
      referralNeeds: ['工廠', '養護機構', '老人看護'],
      description: '擁有豐富的人力資源經驗，個人喜好旅行、學習語言，愛交朋友。致力於媒合優質人才與企業需求，服務範疇涵蓋多元產業。'
    },
    {
      name: '游博硯',
      industry: '數位行銷業',
      avatar: 'https://static.readdy.ai/image/5ea2d03b33219ef9494c85fcc936fae1/e145de4c3cbd029bd9d0114e098cf987.png',
      company: '時川國際有限公司',
      position: '創辦人暨執行長',
      coverTags: ['廣告投放', 'AI自動化流程', '短影音'],
      specialties: ['TikTok 廣告投放', 'Facebook 廣告優化', 'Instagram 社群經營', 'AI 大數據收集分析', '高回報素材製作', '短視頻內容策劃', 'AI自動化流程', '網站製作'],
      referralNeeds: ['有廣告投放需求的品牌', '電商業者', '需要 AI 自動化的企業', '新創公司'],
      description: '專注於數位廣告領域超過 10 年，擅長運用 AI 技術進行大數據分析，為客戶打造高轉換率的廣告素材與短視頻內容，協助眾多品牌在社群平台上取得卓越成效。'
    },
    {
      name: '陳建志',
      industry: '科技業',
      avatar: 'https://public.readdy.ai/ai/img_res/23fa9ec50d6ff17a34f378554216bf9e.jpg',
      company: '科技創新股份有限公司',
      position: '技術長',
      specialties: ['軟體開發', '系統架構', '雲端服務', '技術團隊管理'],
      referralNeeds: ['企業 IT 解決方案需求', '軟體開發外包合作', '雲端服務導入'],
      description: '擁有豐富的軟體開發與系統架構經驗，帶領技術團隊打造多項成功產品。'
    },
    {
      name: '林雅婷',
      industry: '金融業',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20executive%20headshot%2C%20age%2030-40%2C%20confident%20smile%2C%20business%20attire%2C%20clean%20white%20background%2C%20corporate%20portrait%20photography&width=200&height=200&seq=member-2-ymc&orientation=squarish',
      company: '財富管理顧問公司',
      position: '資深顧問',
      specialties: ['財務規劃', '投資管理', '風險評估', '資產配置'],
      referralNeeds: ['高資產客戶理財需求', '企業主財務規劃', '投資組合管理'],
      description: '專精於高資產客戶的財務規劃與投資管理，協助客戶達成財務目標。'
    },
    {
      name: '王俊傑',
      industry: '製造業',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20entrepreneur%20headshot%2C%20age%2035-45%2C%20friendly%20expression%2C%20business%20suit%2C%20clean%20white%20background%2C%20professional%20photography&width=200&height=200&seq=member-3-ymc&orientation=squarish',
      company: '精密製造有限公司',
      position: '總經理',
      specialties: ['生產管理', '品質控制', '供應鏈優化', '自動化導入'],
      referralNeeds: ['原物料供應商', '自動化設備廠商', '工廠智慧化顧問'],
      description: '深耕製造業多年，專注於生產效率提升與品質管理，推動工廠智慧化轉型。'
    },
    {
      name: '張美玲',
      industry: '服務業',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20leader%20headshot%2C%20age%2030-40%2C%20warm%20smile%2C%20professional%20attire%2C%20clean%20white%20background%2C%20corporate%20photography&width=200&height=200&seq=member-4-ymc&orientation=squarish',
      company: '優質服務集團',
      position: '營運總監',
      specialties: ['客戶服務', '營運管理', '團隊培訓', '服務流程優化'],
      referralNeeds: ['企業教育訓練需求', '服務流程改善顧問', '人才培訓合作'],
      description: '致力於提升服務品質與客戶體驗，建立高效的服務團隊與流程。'
    },
    {
      name: '李宗翰',
      industry: '貿易業',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20executive%20headshot%2C%20age%2035-45%2C%20confident%20expression%2C%20business%20casual%2C%20clean%20white%20background%2C%20professional%20portrait&width=200&height=200&seq=member-5-ymc&orientation=squarish',
      company: '國際貿易股份有限公司',
      position: '業務總監',
      specialties: ['國際貿易', '市場開發', '客戶關係管理', '跨境電商'],
      referralNeeds: ['有進出口需求的廠商', '東南亞市場開拓夥伴', '跨境電商合作'],
      description: '擁有豐富的國際貿易經驗，開拓多國市場，建立穩固的海外客戶網絡。'
    },
    {
      name: '黃淑芬',
      industry: '零售業',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20entrepreneur%20headshot%2C%20age%2030-40%2C%20professional%20smile%2C%20business%20attire%2C%20clean%20white%20background%2C%20corporate%20portrait&width=200&height=200&seq=member-6-ymc&orientation=squarish',
      company: '時尚零售連鎖',
      position: '品牌總監',
      specialties: ['品牌經營', '零售管理', '商品企劃', '通路拓展'],
      referralNeeds: ['品牌授權合作', '加盟展店意向客戶', '零售通路供應商'],
      description: '專注於品牌形象塑造與零售通路經營，成功打造多個知名零售品牌。'
    }
  ];

  const industries = ['全部', ...Array.from(new Set(members.map(m => m.industry)))];

  const filteredMembers = activeFilter === '全部'
    ? members
    : members.filter(m => m.industry === activeFilter);

  return (
    <section id="members" className="py-16 sm:py-24 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-xs sm:text-sm font-semibold text-orange-500 mb-3 tracking-[0.2em] uppercase">Our Members</p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-purple-900 mb-5 leading-tight">
            會員名冊
          </h2>
          {/* Decorative line */}
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-16 bg-purple-100"></div>
            <div className="w-2 h-2 rounded-full bg-orange-400"></div>
            <div className="h-px w-16 bg-purple-100"></div>
          </div>
          <p className="text-stone-500 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
            各行各業的精英企業家，共同組成 YMC Taipei 的核心力量
          </p>
        </div>

        {/* Industry Filter */}
        <div className="flex flex-wrap gap-2 justify-center mb-10 sm:mb-14">
          {industries.map((industry) => (
            <button
              key={industry}
              onClick={() => setActiveFilter(industry)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeFilter === industry
                  ? 'bg-purple-900 text-white shadow-[0_4px_12px_rgba(88,28,135,0.25)]'
                  : 'bg-white text-stone-600 border border-stone-200 hover:border-purple-300 hover:text-purple-900'
              }`}
            >
              {industry}
            </button>
          ))}
        </div>

        {/* Members Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6 mb-16 sm:mb-20">
          {filteredMembers.map((member, index) => {
            const originalIndex = members.findIndex(m => m.name === member.name);
            return (
              <div
                key={index}
                onClick={() => setSelectedMember(originalIndex)}
                className="group bg-white border border-stone-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 shadow-[0_2px_8px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
              >
                {/* Top accent bar */}
                <div className="h-1 w-full bg-gradient-to-r from-orange-400 to-amber-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                <div className="p-5">
                  {/* Avatar + Name */}
                  <div className="flex items-center gap-4 mb-5">
                    <div className="relative flex-shrink-0">
                      <img
                        src={member.avatar}
                        alt={member.name}
                        className="w-16 h-16 rounded-full object-cover ring-2 ring-stone-100 group-hover:ring-orange-200 transition-all duration-300"
                      />
                      <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-emerald-400 rounded-full border-2 border-white"></div>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-lg font-extrabold text-stone-900 truncate">{member.name}</h3>
                        {member.isPresident && (
                          <span className="flex items-center gap-1 px-2 py-0.5 bg-amber-400 rounded-full flex-shrink-0">
                            <i className="ri-crown-fill text-[10px] text-white w-3 h-3 flex items-center justify-center"></i>
                            <span className="text-[10px] font-bold text-white">社長</span>
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-orange-500 font-medium truncate mt-0.5">{member.position}</p>
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="h-px bg-stone-100 mb-4"></div>

                  {/* Company & Industry */}
                  <div className="space-y-2.5 mb-4">
                    <div className="flex items-center gap-2.5">
                      <div className="w-6 h-6 flex items-center justify-center rounded-md bg-stone-100 flex-shrink-0">
                        <i className="ri-building-line text-xs text-stone-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                      </div>
                      <span className="text-sm text-stone-600 truncate">{member.company}</span>
                    </div>
                    <div className="flex items-center gap-2.5">
                      <div className="w-6 h-6 flex items-center justify-center rounded-md bg-orange-50 flex-shrink-0">
                        <i className="ri-briefcase-line text-xs text-orange-400 w-3.5 h-3.5 flex items-center justify-center"></i>
                      </div>
                      <span className="text-sm font-semibold text-stone-700">{member.industry}</span>
                    </div>
                  </div>

                  {/* Specialties + Arrow */}
                  <div className="flex items-end justify-between gap-2 mt-4 pt-4 border-t border-stone-100">
                    <div className="flex gap-1.5 flex-wrap">
                      {(member.coverTags ?? member.specialties.slice(0, 2)).map((s, i) => (
                        <span key={i} className="text-[11px] text-stone-500 bg-stone-50 border border-stone-150 px-2 py-0.5 rounded-full">{s}</span>
                      ))}
                    </div>
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-stone-50 group-hover:bg-purple-600 transition-colors duration-300 flex-shrink-0">
                      <i className="ri-arrow-right-line text-xs text-stone-400 group-hover:text-white w-3.5 h-3.5 flex items-center justify-center transition-colors duration-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>

      {/* Member Detail Modal */}
      {selectedMember !== null && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-0 sm:p-6"
          onClick={() => setSelectedMember(null)}
        >
          <div
            className="bg-white rounded-t-3xl sm:rounded-2xl w-full sm:max-w-lg relative max-h-[92vh] overflow-y-auto shadow-[0_20px_60px_rgba(0,0,0,0.2)] member-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Drag handle — mobile only */}
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className="w-10 h-1 rounded-full bg-gray-200"></div>
            </div>

            {/* Modal top accent — desktop only */}
            <div className="hidden sm:block h-1.5 w-full bg-gradient-to-r from-orange-400 to-amber-300 rounded-t-2xl"></div>

            <div className="p-5 sm:p-8">
              <button
                onClick={() => setSelectedMember(null)}
                className="absolute top-4 right-4 sm:top-5 sm:right-5 w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 hover:bg-stone-200 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-base text-stone-600 w-4 h-4 flex items-center justify-center"></i>
              </button>

              <div className="flex items-center gap-4 sm:gap-5 mb-5 sm:mb-6 pr-10">
                <img
                  src={members[selectedMember].avatar}
                  alt={members[selectedMember].name}
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover flex-shrink-0 ring-4 ring-orange-100 shadow-[0_4px_12px_rgba(0,0,0,0.1)]"
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <h3 className="text-xl sm:text-2xl font-black text-stone-900">
                      {members[selectedMember].name}
                    </h3>
                    {members[selectedMember].isPresident && (
                      <span className="flex items-center gap-1 px-2 py-0.5 bg-amber-400 rounded-full flex-shrink-0">
                        <i className="ri-crown-fill text-[10px] text-white w-3 h-3 flex items-center justify-center"></i>
                        <span className="text-[10px] font-bold text-white">社長</span>
                      </span>
                    )}
                  </div>
                  <p className="text-xs sm:text-sm text-orange-500 font-semibold mb-1 truncate">
                    {members[selectedMember].position}
                  </p>
                  <p className="text-xs sm:text-sm text-stone-500 truncate">{members[selectedMember].company}</p>
                  <span className="inline-block mt-1.5 px-2.5 py-0.5 bg-orange-50 border border-orange-200 rounded-full text-xs text-orange-700 font-semibold">
                    {members[selectedMember].industry}
                  </span>
                </div>
              </div>

              <div className="h-px bg-stone-100 mb-4 sm:mb-5"></div>

              <div className="space-y-4 sm:space-y-5">
                {/* 關於 */}
                <div>
                  <h4 className="text-xs font-bold text-stone-400 uppercase tracking-widest mb-2">關於我</h4>
                  <p className="text-stone-600 leading-relaxed text-sm">
                    {members[selectedMember].description}
                  </p>
                </div>

                {/* 引薦需求 */}
                {members[selectedMember].referralNeeds && members[selectedMember].referralNeeds.length > 0 && (
                  <div className="rounded-xl bg-amber-50 border border-amber-200 p-3.5 sm:p-4">
                    <div className="flex items-center gap-2 mb-2.5 sm:mb-3">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-amber-400 flex-shrink-0">
                        <i className="ri-arrow-right-up-line text-[11px] text-white w-3 h-3 flex items-center justify-center"></i>
                      </div>
                      <h4 className="text-xs font-bold text-amber-700 uppercase tracking-widest">引薦需求</h4>
                    </div>
                    <div className="flex flex-wrap gap-1.5 sm:gap-2">
                      {members[selectedMember].referralNeeds.map((need, idx) => (
                        <span
                          key={idx}
                          className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1 sm:py-1.5 bg-white border border-amber-200 rounded-full text-xs text-amber-800 font-semibold"
                        >
                          <i className="ri-checkbox-circle-line w-3 h-3 flex items-center justify-center text-amber-500"></i>
                          {need}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* 專業領域 */}
                <div>
                  <h4 className="text-xs font-bold text-stone-400 uppercase tracking-widest mb-2 sm:mb-3">專業領域</h4>
                  <div className="flex flex-wrap gap-1.5 sm:gap-2">
                    {members[selectedMember].specialties.map((specialty, idx) => (
                      <span
                        key={idx}
                        className="px-2.5 sm:px-3 py-1 sm:py-1.5 bg-stone-50 border border-stone-200 rounded-full text-xs text-stone-700 font-medium"
                      >
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="pt-3 border-t border-stone-100 flex gap-2.5 sm:gap-3 member-modal-footer">
                  <button
                    onClick={() => { setSelectedMember(null); navigate('/contact'); }}
                    className="flex-1 py-3.5 bg-purple-900 hover:bg-purple-800 text-white rounded-xl font-semibold transition-colors whitespace-nowrap text-sm cursor-pointer"
                  >
                    聯絡我們
                  </button>
                  <button
                    onClick={() => setSelectedMember(null)}
                    className="px-5 sm:px-6 py-3.5 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-xl font-semibold transition-colors whitespace-nowrap text-sm cursor-pointer"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes memberModalUp {
          from { transform: translateY(60px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        @keyframes memberModalFade {
          from { opacity: 0; transform: scale(0.97); }
          to   { opacity: 1; transform: scale(1); }
        }
        .member-modal {
          animation: memberModalUp 0.32s cubic-bezier(0.32, 0.72, 0, 1);
        }
        @media (min-width: 640px) {
          .member-modal {
            animation: memberModalFade 0.25s ease-out;
          }
        }
        .member-modal-footer {
          padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
        }
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}
